import { render, staticRenderFns } from "./TransactionRecordComponent.vue?vue&type=template&id=46c154ed&"
import script from "./TransactionRecordComponent.vue?vue&type=script&lang=js&"
export * from "./TransactionRecordComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports